import { useQuery } from 'react-query';
import axios from 'axios';
import { RatingAPI } from '../../constants/API';
import { RatingStateDto, RatingWorkplaceParams } from '../../types/Rating/RatingTypes';
import { formatWorkplaceNumber } from '../../utils/Rating/parseRatingParams';

export const useRatingState = (workplace: RatingWorkplaceParams | null) => {
  return useQuery(
    ['ratingState', workplace],
    async () => {
      const { data } = await axios.get<RatingStateDto>(RatingAPI.getState, {
        params: {
          branch: workplace!.branch,
          queue: workplace!.queue,
          cabinet: formatWorkplaceNumber(workplace!.cabinet),
          window: formatWorkplaceNumber(workplace!.window)
        }
      });
      return data;
    },
    {
      enabled: workplace != null,
      refetchInterval: 2500,
      refetchIntervalInBackground: true
    }
  );
};
